define('page/fuelcms', ['jquery', 'jquery.qrcode'], ($) => {
    // 车主故事详情页
    const shareImage = `${window.location.protocol}/dist/images/renrenche-icon-87acca6c.png`;

    function switchSelfCarousel() {
        const self_carousel = $('#self_carousel');
        const item_length = $('.carousel-item').length;
        let now_index = 0;
        self_carousel.css('width', `${item_length * 595}px`);

        $('#c_next').on('click', () => {
            now_index++;
            if (now_index > Math.ceil(item_length / 2) - 1) {
                now_index = 0;
            }
            self_carousel.css('left', `${-1190 * now_index}px`);
        });

        $('#c_prev').on('click', () => {
            now_index--;
            if (now_index < 0) {
                now_index = Math.ceil(item_length / 2) - 1;
            }
            self_carousel.css('left', `${-1190 * now_index}px`);
        });
    }

    // share to qq
    function shareToQq() {
        const shareTitle = document.title;
        const shareContent = '人人车';
        const p = {
            url: location.href,
            pics: shareImage,
            desc: shareContent,
            title: shareTitle,
        };
        const s = [];
        for (const i in p) {
            s.push(`${i}=${encodeURIComponent(p[i] || '')}`);
        }

        const ndQQZone = $('#cms_share_qqzone');
        ndQQZone.attr('href', `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${s.join('&')}`);
    }

    function share() {
        (((s, d, e) => {
            const f = 'http://v.t.sina.com.cn/share/share.php?';
            const u = location.href;
            const p = ['url=', e(u), '&title=', e(window.sharetitle), '&appkey=2924220432', '&pic=', e(window.shareUrl)].join(''); // eslint-disable-line

            function a() {
                if (!window.open([f, p].join(''), 'mb', ['toolbar=0,status=0,resizable=1,width=620,height=450,left=', (s.width - 620) / 2, ',top=', (s.height - 450) / 2].join(''))) { // eslint-disable-line
                    u.href = [f, p].join('');
                }
            }

            if (/Firefox/.test(navigator.userAgent)) {
                setTimeout(a, 0);
            } else {
                a();
            }
        }))(screen, document, encodeURIComponent);
    }

    // share to weibo
    function shareToWeibo() {
        $('#cms_share_weibo').on('click', () => {
            window.sharetitle = document.title;
            window.shareUrl = shareImage;
            share(); // eslint-disable-line
        });
    }

    function shareToWeixin() {
        $('#cms_share_weixin').on('mouseover', () => {
            $('.sms-weixin-section').css('display', 'block');
        });

        $('#cms_share_weixin').on('mouseout', () => {
            $('.sms-weixin-section').css('display', 'none');
        });

        const ndWeixinLogo = $('#js-weixin-logo');
        ndWeixinLogo.qrcode({
            render: 'image',
            text: ndWeixinLogo.data('url'),
            size: 90,
        });
    }

    function init() {
        switchSelfCarousel();
        shareToQq();
        shareToWeibo();
        shareToWeixin();
    }

    return {
        init,
        shareToQq,
        shareToWeibo,
        shareToWeixin,
    };
});
/* istanbul ignore if */
if (typeof window.__karma__ === 'undefined') {
    require(['page/fuelcms'], (page) => {
        page.init();
    });
}
